import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode, faSmile, faIceCream, faClock, faSignature } from '@fortawesome/free-solid-svg-icons';
import './TableTales.css';
import tabletalesimage from '../../assets/pageimages/TableTales.webp';

function TableTalesHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>TableTales</h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/tabletales-welcome" className="top-button-link"><FontAwesomeIcon icon={faSmile} className="tabletales-bottomlink-style" />Welcome Launge</Link></div>
            <div className="bottom-buttons-box"><Link to="/tabletales-trymyluck-scan" className="top-button-link"><FontAwesomeIcon icon={faGift} className="tabletales-bottomlink-style" />Waiting Luck</Link></div>
            <div className="bottom-buttons-box"><Link to="/tabletales-menu-scan" className="top-button-link"><FontAwesomeIcon icon={faIceCream} className="tabletales-bottomlink-style" />Menu</Link></div>
            <div className="bottom-buttons-box"><Link to="/tabletales-order-status" className="top-button-link"><FontAwesomeIcon icon={faClock} className="tabletales-bottomlink-style" />Order Status</Link></div>
            <div className="bottom-buttons-box"><Link to="/tabletales-signoff" className="top-button-link"><FontAwesomeIcon icon={faSignature} className="tabletales-bottomlink-style" />Signoff</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="tabletales-id" src={tabletalesimage} alt="TableTales Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default TableTalesHome;
